import Link from 'next/link';
import { useContext } from 'react';
import StationSettings from '@/components/modules/StationSettings';
import LanguageLocalizer from '@/utils/language-localization';
import styles from './SharedFooterLinks.module.scss';

export default function SharedFooterLinks() {
  const { __t } = new LanguageLocalizer( useContext, 'components/global/SiteFooter' );

  return <>
    <div className={styles.bottomWrapper}>
      <ul className={styles.bottomLinkGrid}>
        <li><StationSettings wrapperClass={styles.stationSettingsWrapper} /></li>
        <li><Link href={'/privacy/'}>{__t('privacyPolicy')}</Link></li>
        <li><Link href={'/privacy/termsofuse.html'}>{__t('termsOfUse')}</Link></li>
      </ul>
      <span className={styles.copyright}>pbskids.org &copy; {new Date().getFullYear()}</span>
    </div>
  </>;
}
